import { render, staticRenderFns } from "./OrComponent.vue?vue&type=template&id=38e794f3&scoped=true"
import script from "./OrComponent.vue?vue&type=script&lang=js"
export * from "./OrComponent.vue?vue&type=script&lang=js"
import style0 from "./OrComponent.vue?vue&type=style&index=0&id=38e794f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e794f3",
  null
  
)

export default component.exports